function initScroller(e) {
  let t = qsa(".scroller__dots span", e);
  t.forEach((t) => {
    t.onclick = () => {
      toggleClass(e, t, "active");
    };
  });
  let s = qsa(".scroller__item", e),
    o = qs(".scroller__cont", e),
    r = o.dataset.cols;
  const c = new IntersectionObserver(
    (s, o) => {
      s.forEach((s) => {
        if (s.isIntersecting) {
          const o = s.target.dataset.slide;
          if (o % r == 0) {
            toggleClass(e, t[o / r], "active");
          }
        }
      });
    },
    { root: o, threshold: 0 }
  );
  s.forEach((e) => {
    c.observe(e);
  });
}
function toggleClass(e, t, s) {
  e.querySelector(".scroller__dots .active").classList.remove(s),
    t.classList.add(s);
}
document.addEventListener("DOMContentLoaded", function (e) {
  qsa(".scroller").forEach((e) => {
    initScroller(e);
  });
});

const buttons = document.querySelectorAll(".upsell-btn").forEach((button) => {
  button.addEventListener("click", (e) => e.preventDefault());
});

const buttons2 = document.querySelectorAll("#upsell-btn2").forEach((button) => {
  
  button.addEventListener("click", (e) => e.preventDefault());
console.log("🚀 ~ file: global-custom.js:45 ~ buttons2 ~ button:", button)
});